<template>
  <div class="container" style="display: flex; flex-direction: row; margin-top: 8px;">
    <div style="width: 620px;">
      <div>
        <el-button
            type="primary"
            icon="el-icon-s-promotion"
            @click="generateCover">
          生成封面
        </el-button>
        <el-button
            type="primary"
            icon="el-icon-download"
            @click="downloadCover">
          下载封面
        </el-button>
      </div>
      <div style="margin-top: 16px; width: 480px;background: #FFCCCC;">
        <el-radio-group v-model="rowNum" style="line-height: 32px;">
          <el-radio :label="2">2个</el-radio>
          <el-radio :label="4">4个</el-radio>
          <el-radio :label="8">8个</el-radio>
          <el-radio :label="10">10个</el-radio>
          <el-radio :label="12">12个</el-radio>
          <el-radio :label="16">16个</el-radio>
          <el-radio :label="101">壁纸窝1个</el-radio>
          <el-radio :label="102">壁纸窝2个</el-radio>
        </el-radio-group>
        <div style="margin-top: 8px; width: 480px;background: #CCFFCC;">
          背景色：
          <el-color-picker v-model="backgroundColor"></el-color-picker>
          边框色：
          <el-color-picker v-model="borderColor"></el-color-picker>
        </div>
      </div>
      <Tinymce
          v-model="result1"
          ref="editor1"
          width="620"
          height="640"
          style="margin-top: 8px;"/>
    </div>
    <div style="width: 940px;position: relative; margin-left: 16px;">
      <canvas ref="cover" style="width: 940px; height: 940px; border: #333333 solid 1px;position: absolute;"/>
      <canvas ref="cover2" style="border: #333333 solid 1px;position: absolute;display: none;"/>
      <canvas ref="cover383" style="border: #333333 solid 1px;position: absolute;display: none;"/>
      <hr style="width: 940px; margin: 0; position: absolute;top: 270px;"/>
      <hr style="width: 940px; margin: 0; position: absolute;top: 670px;"/>
    </div>
  </div>
</template>
<script>
import Tinymce from '@/Tinymce'

let ctx, ctx2, ctx383, canvas, canvas2, canvas383, width = 940, height = 400, topPadding, padding2 = 8, coverBgImg;
const devicePixelRatio = 2;//window.devicePixelRatio;
export default {
  name: "CoverGenerator",
  components: {Tinymce},
  data() {
    return {
      gzh: 0,
      startGifUrl: "",
      recommendGzhStart: 0,
      recommendGzhEnd: 0,
      gzhNameList: [
        '怪味冰激凌',
        '甜情头',
        '甜句子',
        '优质头像精选',
        '壁纸窝',
        '来不及学坏',
      ],
      recommendGzhNameList: [
        '无',
        '怪味冰激凌',
        '甜情头',
        '甜句子',
        '优质头像精选',
        '壁纸窝',
        '来不及学坏',
      ],
      urlInput: '',
      rowNum: 2,
      result: "",
      hasStart: 0,
      hasEnd: 0,
      footType: 0,
      shadowType: 0,
      waterMarkType: 0,
      activeTab: "result1",
      result1: "",
      result2: "",
      result3: "",
      result4: "",
      result5: "",
      result6: "",
      result7: "",
      result8: "",
      roted: 0,
      backgroundColor: '#FFFFFF',
      borderColor: '#000000',
      leftVerticalMargin: (width - ((width - padding2) / 2)) / 2,
      rightVerticalMargin: (width - ((width - padding2) / 2)) / 2,
      bzwLeftVerticalMargin: 0,
      bzwRightVerticalMargin: 0,
      verticalMargin: 0,
      downloadedImage: new Map(),
    }
  },
  mounted() {
    let that = this;
    topPadding = (width - height) / 2 - 2;
    // 背景图
    coverBgImg = new Image();
    coverBgImg.src = require('@/assets/cover_bg.png');
    coverBgImg.crossOrigin = '';
    canvas = this.$refs.cover;
    canvas2 = this.$refs.cover2;
    canvas383 = this.$refs.cover383;
    ctx = canvas.getContext("2d");
    ctx2 = canvas2.getContext("2d");
    ctx383 = canvas383.getContext("2d");
    ctx.mozImageSmoothingEnabled = false;
    ctx.webkitImageSmoothingEnabled = false;
    ctx.msImageSmoothingEnabled = false;
    ctx.imageSmoothingEnabled = false;
    ctx2.mozImageSmoothingEnabled = false;
    ctx2.webkitImageSmoothingEnabled = false;
    ctx2.msImageSmoothingEnabled = false;
    ctx2.imageSmoothingEnabled = false;
    ctx383.mozImageSmoothingEnabled = false;
    ctx383.webkitImageSmoothingEnabled = false;
    ctx383.msImageSmoothingEnabled = false;
    ctx383.imageSmoothingEnabled = false;
    canvas.height = width * devicePixelRatio;
    canvas.width = width * devicePixelRatio;
    ctx.scale(devicePixelRatio, devicePixelRatio);
    canvas2.height = width * devicePixelRatio;
    canvas2.width = width * devicePixelRatio;
    ctx2.scale(devicePixelRatio, devicePixelRatio);
    canvas383.height = height * devicePixelRatio;
    canvas383.width = width * devicePixelRatio;
    ctx383.scale(devicePixelRatio, devicePixelRatio);
    canvas.onmousedown = function (event) {
      var pos = that.windowToCanvas(event.clientX, event.clientY);  //坐标转换，将窗口坐标转换成canvas的坐标
      var rect = canvas.getBoundingClientRect();
      var px = event.clientX - rect.left;

      canvas.onmousemove = function (evt) {  //移动
        var posl = that.windowToCanvas(evt.clientX, evt.clientY);
        var x = posl.x - pos.x;
        var y = posl.y - pos.y;
        pos = posl;
        if (that.rowNum === 2) {
          if (px < (width / 2)) {
            that.leftVerticalMargin = that.leftVerticalMargin + y;
          } else {
            that.rightVerticalMargin = that.rightVerticalMargin + y;
          }
          that.copyCanvas2();
        } else if (that.rowNum === 101) {
          that.verticalMargin = that.verticalMargin + y;
          that.draw101();
        } else if (that.rowNum === 102) {
          if (px < (width / 2)) {
            that.bzwLeftVerticalMargin = that.bzwLeftVerticalMargin + y;
          } else {
            that.bzwRightVerticalMargin = that.bzwRightVerticalMargin + y;
          }
          that.draw102();
        }
      };

      canvas.onmouseup = function () {
        canvas.onmousemove = null;
        canvas.onmouseup = null;
      };
    };
    ctx.save();
    ctx2.save();
  },
  methods: {
    generateCover() {
      ctx.restore();
      ctx.save();
      ctx2.restore();
      ctx2.save();
      let that = this;
      ctx.fillStyle = this.backgroundColor;
      ctx.fillRect(0, 0, width, height);
      //ctx.shadowBlur=8;
      //ctx.shadowColor="#000000";
      let picWidth = 0;
      let horMargin = 0;
      let verticalMargin = 0;
      // 遍历所有图片
      that.downloadedImage = new Map();
      let imgArr = this.result1.split("<img");
      for (let i = 1; i < this.rowNum + 1 && i < imgArr.length; i++) {
        let imgTemp = imgArr[i];
        imgTemp = imgTemp.substring(imgTemp.indexOf(" src=\"") + 6);
        imgTemp = imgTemp.substring(0, imgTemp.indexOf("\""));
        that.$api
            .post('https://api.cuntubang.com/CwHelper/forceDownloadResource',
                {
                  unionId: '123',
                  //resourceType: that.resourceType,
                  webUrl: imgTemp,
                  imgUrlList: [imgTemp]
                })
            .then(response => {
              if (response.data.resultCode === 0 && response.data.imgUrlList && response.data.imgUrlList.length > 0) {
                let img = new Image();
                img.onload = function () {
                  that.downloadedImage.set(i - 1, img);
                  if (that.rowNum === 2) {
                    if (that.downloadedImage.size === 2) {
                      that.copyCanvas2();
                    }
                  } else if (that.rowNum === 4) {
                    if (that.downloadedImage.size === 3) {
                      that.draw4();
                    }
                  } else if (that.rowNum === 8) {
                    if (that.downloadedImage.size === 4) {
                      that.draw8();
                    }
                  } else if (that.rowNum === 10) {
                    if (that.downloadedImage.size === 10) {
                      that.copyCanvas10();
                    }
                  } else if (that.rowNum === 12) {
                    if (that.downloadedImage.size === 12) {
                      that.copyCanvas12();
                    }
                  } else if (that.rowNum === 16) {
                    if (that.downloadedImage.size === 16) {
                      that.draw16();
                    }
                  } else if (that.rowNum === 101) {
                    if (that.downloadedImage.size === 1) {
                      that.draw101();
                    }
                  } else if (that.rowNum === 102) {
                    if (that.downloadedImage.size === 2) {
                      that.draw102();
                    }
                  }
                }
                img.src = response.data.imgUrlList[0];
                img.crossOrigin = '';
              }
            });
      }
    },
    copyCanvas2() {
      ctx.clearRect(0, 0, width, width);
      ctx2.clearRect(0, 0, width, width);
      ctx.drawImage(coverBgImg, 0, 0, width, width);
      let horMargin = padding2;
      let picWidth = (width - horMargin) / 2;
      let img1 = this.downloadedImage.get(0);
      let piHeight1 = picWidth / img1.width * img1.height;
      ctx2.drawImage(img1, 0, this.leftVerticalMargin, picWidth, piHeight1);
      let img2 = this.downloadedImage.get(1);
      let piHeight2 = picWidth / img2.width * img2.height;
      ctx2.drawImage(img2, picWidth + horMargin, this.rightVerticalMargin, picWidth, piHeight2);
      ctx.drawImage(canvas2, 0, topPadding * devicePixelRatio, width * devicePixelRatio, height * devicePixelRatio, 0, topPadding, width, height);
    },
    draw4() {
      ctx.clearRect(0, 0, width, width);
      ctx.fillStyle = this.backgroundColor;
      ctx.fillRect(0, 0, width, width);
      let horMargin = 0;
      let picWidth = (width - horMargin) / 2;
      for (let i = 0; i < this.downloadedImage.size; i++) {
        let x = picWidth * (i % 2) + horMargin * (i % 2);
        let y = picWidth * parseInt(i / 2) + horMargin * parseInt(i / 2);
        ctx.drawImage(this.downloadedImage.get(i), x, y, picWidth, picWidth);
      }
    },
    draw8() {

    },
    copyCanvas10() {
      ctx.clearRect(0, 0, width, width);
      ctx.fillStyle = this.backgroundColor;
      ctx.fillRect(0, 0, width, width);
      let horMargin = 16;
      let picWidth = (width - horMargin * 6) / 5;
      let verMargin = (height - picWidth * 2 - horMargin) / 2;
      //画圆角
      for (let i = 0; i < this.downloadedImage.size; i++) {
        let x = picWidth * (i % 5) + horMargin * ((i % 5) + 1);
        let y = picWidth * parseInt(i / 5) + horMargin * parseInt(i / 5) + topPadding + verMargin;
        this.drawRoundedRect(x, y, picWidth, picWidth, 24);
      }
      ctx.clip();
      for (let i = 0; i < this.downloadedImage.size; i++) {
        let x = picWidth * (i % 5) + horMargin * ((i % 5) + 1);
        let y = picWidth * parseInt(i / 5) + horMargin * parseInt(i / 5) + topPadding + verMargin;
        ctx.drawImage(this.downloadedImage.get(i), x, y, picWidth, picWidth);
      }
    },
    copyCanvas12() {
      ctx.clearRect(0, 0, width, width);
      ctx.fillStyle = this.backgroundColor;
      ctx.fillRect(0, 0, width, width);
      let horMargin = 12;
      let picWidth = (width - horMargin * 7) / 6;
      let verMargin = (height - picWidth * 2 - horMargin) / 2;
      //画圆角
      for (let i = 0; i < this.downloadedImage.size; i++) {
        let x = picWidth * (i % 6) + horMargin * ((i % 6) + 1);
        let y = picWidth * parseInt(i / 6) + horMargin * parseInt(i / 6) + topPadding + verMargin;
        this.drawRoundedRect(x, y, picWidth, picWidth, 16);
      }
      ctx.clip();
      for (let i = 0; i < this.downloadedImage.size; i++) {
        let x = picWidth * (i % 6) + horMargin * ((i % 6) + 1);
        let y = picWidth * parseInt(i / 6) + horMargin * parseInt(i / 6) + topPadding + verMargin;
        ctx.drawImage(this.downloadedImage.get(i), x, y, picWidth, picWidth);
      }
    },
    draw16() {
      this.roted = -30 * Math.PI / 180;
      ctx.translate(width / 2, height / 2);
      ctx.rotate(this.roted);
      ctx.translate(-width / 2, -height / 2);
      let that = this;
      let picWidth = 216;
      let horMargin = (width - picWidth * 4) / 3;
      let verticalMargin = (height - picWidth * 4) / 3;
      //画圆角
      for (let i = 0; i < this.downloadedImage.size; i++) {
        let x = picWidth * (i % 4) + horMargin * (i % 4);
        let y = picWidth * parseInt(i / 4) + verticalMargin * parseInt(i / 4);
        that.drawRoundedRect(x, y, picWidth, picWidth, 24);
      }
      ctx.clip();
      for (let i = 0; i < this.downloadedImage.size; i++) {
        let x = picWidth * (i % 4) + horMargin * (i % 4);
        let y = picWidth * parseInt(i / 4) + verticalMargin * parseInt(i / 4);
        ctx.drawImage(this.downloadedImage.get(i), x, y, picWidth, picWidth);
      }
    },
    draw101() {
      ctx.clearRect(0, 0, width, width);
      let img = this.downloadedImage.get(0);
      let drawHeight = width / img.width * img.height;
      ctx.drawImage(this.downloadedImage.get(0), 0, this.verticalMargin, width, drawHeight);
      this.bizhiwo();
    },
    draw102() {
      ctx.clearRect(0, 0, width, width);
      let picWidth = width / 2;
      let img1 = this.downloadedImage.get(0);
      let img2 = this.downloadedImage.get(1);
      let drawHeight1 = picWidth / img1.width * img1.height;
      let drawHeight2 = picWidth / img2.width * img2.height;
      ctx.drawImage(img1, 0, this.bzwLeftVerticalMargin, picWidth, drawHeight1);
      ctx.drawImage(img2, picWidth, this.bzwRightVerticalMargin, picWidth, drawHeight2);
      this.bizhiwo();
    },
    bizhiwo() {
      let fillStyle = "rgba(255,255,255,0.6)";
      let x = width / 5;
      let y = (width - height) / 2 + height / 6;
      let cWidth = width - x * 2;
      let cHeight = height - (height / 6 * 2)
      let cPadding = 24;
      let radius = 16
      ctx.beginPath()
      ctx.moveTo(x + radius, y)
      ctx.lineTo(x + cWidth - radius, y)
      ctx.arc(x + cWidth - radius, y + radius, radius, 1.5 * Math.PI, 2 * Math.PI)
      ctx.lineTo(x + cWidth, y + cHeight - radius)
      ctx.arc(x + cWidth - radius, y + cHeight - radius, radius, 0, 0.5 * Math.PI)
      ctx.lineTo(x + radius, y + cHeight)
      ctx.arc(x + radius, y + cHeight - radius, radius, 0.5 * Math.PI, 1 * Math.PI)
      ctx.lineTo(x, y + radius)
      ctx.arc(x + radius, y + radius, radius, 1 * Math.PI, 1.5 * Math.PI)
      ctx.strokeStyle = fillStyle;
      ctx.lineWidth = 4;
      ctx.stroke();
      x = x + cPadding;
      y = y + cPadding;
      cWidth = cWidth - cPadding * 2;
      cHeight = cHeight - cPadding * 2;
      ctx.beginPath()
      ctx.moveTo(x + radius, y)
      ctx.lineTo(x + cWidth - radius, y)
      ctx.arc(x + cWidth - radius, y + radius, radius, 1.5 * Math.PI, 2 * Math.PI)
      ctx.lineTo(x + cWidth, y + cHeight - radius)
      ctx.arc(x + cWidth - radius, y + cHeight - radius, radius, 0, 0.5 * Math.PI)
      ctx.lineTo(x + radius, y + cHeight)
      ctx.arc(x + radius, y + cHeight - radius, radius, 0.5 * Math.PI, 1 * Math.PI)
      ctx.lineTo(x, y + radius)
      ctx.arc(x + radius, y + radius, radius, 1 * Math.PI, 1.5 * Math.PI)
      ctx.fillStyle = fillStyle;
      ctx.fill();
      ctx.fillStyle = "rgba(0,0,0,0.6)";
      ctx.font = 'bold 48px sans-serif';
      ctx.textAlign = 'center';
      ctx.fillText('壁 / 纸 / 窝', width / 2, width / 2 - 20);
      ctx.font = 'bold 24px sans-serif';
      ctx.fillText('- 每 天 更 新 超 好 看 的 壁 纸 -', width / 2, width / 2 + 48);
    },
    roundRect(x, y, w, h, r) {
      var min_size = Math.min(w, h);
      if (r > min_size / 2) r = min_size / 2;
      // 开始绘制
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.closePath();
      ctx.strokeStyle = this.borderColor;
      ctx.lineWidth = 2;
      ctx.stroke();
    },
    windowToCanvas(x, y) {
      var box = canvas.getBoundingClientRect();  //这个方法返回一个矩形对象，包含四个属性：left、top、right和bottom。分别表示元素各边与页面上边和左边的距离
      return {
        x: x - box.left - (box.width - canvas.width) / 2,
        y: y - box.top - (box.height - canvas.height) / 2
      };
    },
    drawRoundedRect(x, y, width, height, radius) {
      ctx.moveTo(x + radius, y)
      ctx.lineTo(x + width - radius, y)
      ctx.arc(x + width - radius, y + radius, radius, 1.5 * Math.PI, 2 * Math.PI)
      ctx.lineTo(x + width, y + height - radius)
      ctx.arc(x + width - radius, y + height - radius, radius, 0, 0.5 * Math.PI)
      ctx.lineTo(x + radius, y + height)
      ctx.arc(x + radius, y + height - radius, radius, 0.5 * Math.PI, 1 * Math.PI)
      ctx.lineTo(x, y + radius)
      ctx.arc(x + radius, y + radius, radius, 1 * Math.PI, 1.5 * Math.PI)
      ctx.strokeStyle = this.borderColor;
      ctx.lineWidth = 2;
      ctx.stroke();
    },
    onLeftVerticalMarginChange(value) {
      this.leftVerticalMargin = value;
      this.copyCanvas2();
    },
    downloadCover() {
      const MIME_TYPE = "image/png";
      var imgURL;
      if (this.rowNum === 10 || this.rowNum === 12) {
        ctx383.drawImage(canvas, 0, topPadding * devicePixelRatio, width * devicePixelRatio, height * devicePixelRatio, 0, 0, width, height);
        imgURL = canvas383.toDataURL(MIME_TYPE, 1.0);
      } else {
        imgURL = canvas.toDataURL(MIME_TYPE, 1.0);
      }
      var dlLink = document.createElement('a');
      dlLink.download = "cover.png";
      dlLink.href = imgURL;
      dlLink.dataset.downloadurl = [MIME_TYPE, dlLink.download, dlLink.href].join(':');
      document.body.appendChild(dlLink);
      dlLink.click();
      document.body.removeChild(dlLink);
    }
  }
};
</script>

<style>
</style>